import { useMemo, useState } from "react";
import { useUser } from "../context/user-context";
import GetTickers from "../components/utils/GetTickers";
import useAllRates from "../components/utils/GetAllRates";

const availableCoins = ["USDT", "BTC", "DOGE", "ETH", "SHIB", "TRX", "SOL", "USDC", "BNB", "POL"];

const useUserAsset = () => {
  const { userDetails, refetch: fetchUser } = useUser();

  const user = userDetails?.user;
  const rates = useAllRates();

  const [fetching, setFetching] = useState(false);

  const walletBalance = user?.deexWalletBalances;

  const { data: coinRates, isLoading, refetch } = GetTickers();

  const usdtRate = useMemo(() => {
    return rates?.find((r: { abbr: string }) => r.abbr === "USDT")?.rate ?? 0;
  }, [rates]);

  const ngnInUsd = walletBalance ? walletBalance?.ngn / usdtRate : 0;

  const walletBalanceInUsdt = useMemo(() => {
    let balanceInUsdt: { [key: string]: number } = {};
    if (walletBalance && coinRates) {
      availableCoins.forEach((coin: string) => {
        const lowerCaseCoin = coin.toLowerCase();
        const balance = walletBalance[lowerCaseCoin] ?? 0; // Default to 0 if undefined
        const rate = coinRates[coin] ?? 0; // Default to 0 if undefined
        balanceInUsdt[lowerCaseCoin] = balance * rate;
      });
    }
    return balanceInUsdt;
  }, [coinRates, walletBalance]);

  const totalBalance = useMemo(() => {
    if (walletBalanceInUsdt && walletBalance) {
      const walletBalanceInUsdtTotal = Object.values(walletBalanceInUsdt)
        .filter((v) => typeof v === "number" && !isNaN(v)) // Filter out NaN values
        .reduce((a: number, b: number) => a + b, 0); // Add initial value to avoid undefined sums
      return walletBalanceInUsdtTotal;
    }
    return 0;
  }, [walletBalance, walletBalanceInUsdt]) as number;

  const totalBalanceNGN = totalBalance * usdtRate || 0;

  return {
    loading: isLoading || fetching,
    usdtRate,
    totalBalance,
    totalBalanceNGN,
    coinRates: coinRates as { [k: string]: number },
    walletBalance,
    walletBalanceInUsdt,
    ngnInUsd,
    refresh: async () => {
      setFetching(true);
      await refetch();
      await fetchUser(false);
      setFetching(false);
    },
    referralPointsBalance: user?.referralPointsBalance ?? 0,
  };
};

export default useUserAsset;
